import { gql } from "@apollo/client";
import { CurrentUserV2NoNestingFragment } from "@towersystems/roam-common/lib/generated-graphql-fragment";

export const MUTATION_SWITCH_ACTIVE_TERMINAL = gql`
  ${CurrentUserV2NoNestingFragment}
  mutation SwitchActiveTerminal($terminalId: ID!) {
    switchActiveTerminal(terminalId: $terminalId) {
      ...CurrentUserV2NoNesting
    }
  }
`;

export const QUERY_TERMINAL_SESSION_DETAILS = gql`
  query TerminalSessionDetails {
    terminalSessionDetails {
      terminalId
      numberOfActiveSessions
    }
  }
`;
